// covered-by: frontends/carrie/src/ask-v2/transport/__tests__/AskV2ChatFileDrop.test.tsx
import { WARHOL_DOCUMENT_EXTENSIONS } from "@mg/schemas/src/christo/askPuntt";

import { fileMatchesAccept } from "../../components/FileDropzone";

/**
 * Dotted extensions the v2 attach picker offers. In-chat drop uses the same
 * list so a file the picker would refuse is not attached from a drop either.
 */
export const ASK_V2_FILE_ACCEPT = Array.from(WARHOL_DOCUMENT_EXTENSIONS)
  .sort()
  .map((ext) => `.${ext}`);

// why: fileMatchesAccept fails open on an empty pattern list; this list is the picker contract
export function fileMatchesAskV2Accept(file: File): boolean {
  return fileMatchesAccept(file, ASK_V2_FILE_ACCEPT);
}
